/**
 * Types partagés pour les voitures
 */

import {
  effectiveCarBonusFromChampionshipStars,
  clampChampionshipStarLevel,
  migrateLegacyStatToStars,
} from '../game/starLadder.js';

export interface Car {
  id?: number;
  name: string;
  /** Moteur (ligne droite) — étoiles 1–5 */
  engine: number;
  /** Pneu (départ) — étoiles 1–5 */
  tire: number;
  division?: number;
  imagePath?: string | null;
  /** Modèle 3D (Kenney Car Kit) assigné explicitement — sinon choisi par mot-clé sur le nom. */
  model3dPath?: string | null;
}

export function carPower(car: Pick<Car, 'engine' | 'tire'>): number {
  return (car.engine ?? 0) + (car.tire ?? 0);
}

export function effectiveStraightLine(car: Pick<Car, 'engine'>): number {
  return effectiveCarBonusFromChampionshipStars(car.engine ?? 0);
}

export function effectiveStart(car: Pick<Car, 'tire'>): number {
  return effectiveCarBonusFromChampionshipStars(car.tire ?? 0);
}

export function clampCarStat(v: number): number {
  return clampChampionshipStarLevel(v);
}

/** Migration depuis ancien modèle 5 composants 1–5. */
export function migrateLegacyCarStats(legacy: {
  engine?: number;
  tire?: number;
  gearbox?: number;
  brake?: number;
  bodywork?: number;
}): Pick<Car, 'engine' | 'tire'> {
  const scale = (n: number | undefined, fallback: number) =>
    migrateLegacyStatToStars(n ?? fallback);
  return {
    engine: scale(legacy.engine, 3),
    tire: scale(legacy.tire, 3),
  };
}
